module.exports = __webpack_public_path__ + "img/add-icon-gary.618d4bcb.svg";